// Wire-format types for Biometric Data (PRD 09 / FEAT-032).
// Metrics: steps (걸음수), sleep (수면시간), heartRate (안정시 심박수). Weight/BMI excluded by spec (v1.4).

export type BiometricKey = 'steps' | 'sleep' | 'heartRate';

export const BIOMETRIC_KEYS: readonly BiometricKey[] = [
  'steps',
  'sleep',
  'heartRate',
] as const;

export interface BiometricRange {
  warnLow: number;
  normalMin: number;
  normalMax: number;
  warnHigh: number;
}

// Full response from GET /api/biometric
export type BiometricRangesResponse = Record<BiometricKey, BiometricRange>;

// PUT body: update a single metric
export interface BiometricRangeUpdateInput {
  key: BiometricKey;
  range: BiometricRange;
}

export interface BiometricApi {
  getRanges(): Promise<BiometricRangesResponse>;
  updateRange(input: BiometricRangeUpdateInput): Promise<BiometricRange>;
}

export type BiometricApiErrorCode =
  | 'BIOMETRIC_THRESHOLD_ORDER'
  | 'NOT_FOUND'
  | 'INSUFFICIENT_PERMISSION'
  | 'UNKNOWN';

export class BiometricApiError extends Error {
  readonly code: BiometricApiErrorCode;
  readonly fields?: Record<string, string>;

  constructor(
    code: BiometricApiErrorCode,
    message: string,
    fields?: Record<string, string>,
  ) {
    super(message);
    this.name = 'BiometricApiError';
    this.code = code;
    this.fields = fields;
    Object.setPrototypeOf(this, BiometricApiError.prototype);
  }
}
